import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09c1e0a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }

import { ref } from 'vue'
import PathArrow from './PathArrow.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  text: {
    type: String
  },
  active: {
    type: Boolean
  }
},
  setup(__props) {

const props = __props



// let hover = ref(false)
// const onMouseEnter = () => {
//   hover.value = true
// }
// const onMouseLeave = () => {
//   hover.value = false
// }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    class: _normalizeClass(["link", {'active': __props.active}])
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(__props.text), 1)
    ]),
    _createVNode(PathArrow, {
      class: "path",
      active: __props.active
    }, null, 8, ["active"])
  ], 2))
}
}

})